'use strict';
angular.module('reporting.dashboards.controllers')
    .controller('AppController', [
    '$scope',
    '$element',
    '$location',
    function ($scope, $element, $location) {
        $element.toggleClass('invisible');
        $scope.viewMode = 'viewMode';
        $scope.noGlobalWrapper = $location.search().noGlobalWrapper === 'true';
        $scope.showPrintTitle = $location.search().showPrintTitle === 'true';
        $scope.showEndOfReport = $location.search().showEndOfReport === 'true';
        $scope.scrollInfo = {
            selectedIndex: 0,
            visibleIndex: 0,
            jumpToPage: false
        };
    }
]);
